import React from 'react';

const ToteBagIcon = () => {
  return (
    <svg width="44" height="62" viewBox="0 0 44 62" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.99976 15.3232H42.7532V59.9953H1.99976V15.3232Z"
        stroke="#383838"
        strokeWidth="2.26544"
        strokeLinejoin="round"
      />
      <path
        d="M34.8927 15.3232C34.8927 9.36341 35.5712 3.95607 29.6031 2.48666C26.8192 1.80121 16.5053 1.87539 14.0688 2.48666C12.1452 2.96921 9.83691 5.32901 9.83691 9.36341C9.83691 13.3978 9.83691 15.0176 9.83691 15.3232"
        stroke="#383838"
        strokeWidth="2.26544"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ToteBagIcon;
